<template>
  <div class="commonLogin">
    <div class="container">
      <div class="left">
        <div class="trade">
          <router-link to="/normalRegister">
            <h3>普通版</h3>
            <p>一个订单只可支持一个收件人</p>
          </router-link>
        </div>
        <div class="merchant">
          <router-link to="/merchantInfo">
            <h3>商家版</h3>
            <p>特点:</p>
            <p>1、<span>一取多投</span>，一个订单最多可支持 <span>三个收件人</span></p>
            <p>2、<span>一键下单</span>，实现百度外卖、美团外卖、饿了么订单在一线快递中 <span>一键下单</span>
              ，方便快捷
            </p>
          </router-link>
        </div>
      </div>
      <div class="right">
        <register ref="info" @memberRegister="memberRegister" />
        <button class="btn" @click="register">注册</button>
      </div>

    </div>
  </div>
</template>

<script>
import '../../assets/css/login.less'
import Register from '../../components/Login/Register'
import {reqRegister} from '../../api/index'
export default {
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    register () {
      this.$refs.info.verify()
    },
    memberRegister(data) {
      // 全部验证成功
      reqRegister(data).then(res => {
        if(res.code === 200){
          this.$message({
            message:'账号注册成功',
            type:'success'
          })
          this.$router.replace('/login?type=normal')
        }  else if(res.code === 500) {
          this.$message({
            message: res.data.errMsg,
            type: 'error'
          })
        }

      })
    }
  },
  components: {
    Register
  }
}
</script>

<style scoped lang="less" type="text/less">
.commonLogin{
  .container{
    overflow: hidden;
    /*左边*/
    .left{
      margin-top:80px;
      margin-right: 120px;
      float: left;
      div{
        width: 600px;
        height: 280px;
        margin-bottom: 40px;
        border-radius:24px;
        &.trade{
          background: #2FA1DE;
          h3{
            font-size: 32px;
            color:#fff;
            font-weight: 700;
            text-align: center;
            padding-top:98px;
            box-sizing: border-box;
          }
          p{
            margin-top:39px;
            font-weight: 500;
            color:#fff;
            text-align: center;
          }
        }
        &.merchant{
          background: #F6F6F6;
          h3{
            font-size: 32px;
            color:#1A1A1A;
            font-weight: 700;
            text-align: center;
            padding-top:49px;
            box-sizing: border-box;
            margin-bottom: 39px;
          }
          p{
            width: 301px;
            margin:auto;
            color:#1A1A1A;
            margin-bottom: 19px;
            line-height: 20px;
            span{
              color:#2FA1DE;
            }
          }
        }
      }
    }
    .right{
      float: left;
      margin-top:80px;
      .btn {
        width: 100%;
        height: 54px;
        margin-top: 40px;
        margin-bottom: 230px;
        background: #2FA1DE;
        color: #fff;
        border-radius: 27px;
        font-size: 18px;
        border: none;
        cursor: pointer;
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Login/NormalRegister.vue